<ng-template #itemTemplate let-item="item">
  <div class="scenario-selection-panel-scenario-name">
    <div class="line-ellipsis">{{ item.name }}</div>
  </div>
</ng-template>

<ng-template #selectionTemplate let-item="item">
  <div class="filter-name">{{ item.name }}</div>
</ng-template>

<ng-container [formGroup]="editorForm">
  <ca-selector
    #scenarioSelector
    formControlName="editor"
    [url]="scenarioSelectorOptions.url"
    [filters]="scenarioSelectorOptions.filters"
    [itemTemplate]="itemTemplate"
    [selectionTemplate]="selectionTemplate"
    [queryOperator]="scenarioSelectorOptions.queryOperator"
    [queryField]="scenarioSelectorOptions.queryField"
    [multiple]="'true'"
    [emptyText]="scenarioSelectorOptions.emptyText"
    [showSelections]="scenarioSelectorOptions.showSelections"
    [showClearSelections]="scenarioSelectorOptions.showClearSelections"
    [showClearSelectionLink]="scenarioSelectorOptions.showClearSelectionLink"
    [selectorPosition]="scenarioSelectorOptions.selectorPosition"
    [styles]="{ width: '100%', 'border-width': '0px' }"
    [pageSize]="scenarioSelectorOptions.pageSize"
    [currentPage]="scenarioSelectorOptions.currentPage"
   ></ca-selector>
</ng-container>
